import { createAction, createAsyncThunk } from '@reduxjs/toolkit';
import { validatePayload } from '../../../../utils/validate-payload.js';
import { getECCartActionPayload, getECPurchasePayload, } from './cart-selector.js';
import { setItemsPayloadDefinition, itemPayloadDefinition, } from './cart-validation.js';
export const setItems = createAction('commerce/cart/setItems', (payload) => validatePayload(payload, setItemsPayloadDefinition));
export const updateItemQuantity = createAction('commerce/cart/updateItemQuantity', (payload) => validatePayload(payload, itemPayloadDefinition));
export const purchase = createAction('commerce/cart/purchase');
export const emitPurchaseEvent = createAsyncThunk('commerce/cart/emit/purchaseEvent', async (payload, { extra, getState }) => {
    const relayPayload = getECPurchasePayload(payload, getState());
    const { relay } = extra;
    relay.emit('ec.purchase', relayPayload);
});
export const emitCartActionEvent = createAsyncThunk('commerce/cart/emit/cartActionEvent', async (payload, { extra, getState }) => {
    const relayPayload = getECCartActionPayload(payload, getState());
    const { relay } = extra;
    relay.emit('ec.cartAction', relayPayload);
});
